import React, { useEffect, useState } from "react";
import PreviewScreen from "../components/preview/PreviewScreen";
import PreviewNav from "../components/preview/PreviewNav";
import PreviewFooter from "../components/preview/PreviewFooter";
import TwoWayInterview from "../components/interviewRoom/TwoWayInterview";
import Loader from "../components/Loader";
import WebUtils from "../components/utils/WebUtils";
import { getInterviewConfigApi } from "../api";
import useSocket from "../hooks/useSocket";
import { notification } from "antd";

function AiInterviewPreview() {
  const [loading, setLoading] = useState(false);
  const [ip, setIp] = useState();
  const [aiTwoWayFlag, setAiTwoWayFlag] = useState(false);
  const [interviewData, setInterviewData] = useState(null);
  const [previewConfig, setPreviewConfig] = useState({});
  const [conversationHistory, setConversationHistory] = useState({});
  const [currentVideoStream, setCurrentVideoStream] = useState();
  const [screenShareStream, setScreenShareStream] = useState();
  const [currentAudioStream, setCurrentAudioStream] = useState(null);

  const [socket] = useSocket(interviewData);
  const [deepgramStatus, setDeepgramStatus] = useState({
    TrancriptionSocketStatus: false,
    SpeechSynthesisSocketStatus: false,
  });

  const fetchIpAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      setIp(data.ip);
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("interviewDetails");
    if (data) {
      setInterviewData(JSON.parse(data));
    } else {
      setInterviewData({});
    }
    fetchIpAddress();
  }, []);

  const getConfig = () => {
    // setPreviewConfig({
    //   interviewType: "AI_TWO_WAY",
    //   screenRecordingRequired: true,
    //   videoRecordingRequired: true,
    //   transcriptionRequired: true,
    //   snapshotUploadInterval: 5000,
    //   screenshotUploadInterval: 10000,
    //   candidateVideoUploadInterval: 15000,
    //   screenVideoUploadInterval: 20000,
    //   chatHistoryUpdateInterval: 25000,
    // });
    setLoading(true);
    const url = `${getInterviewConfigApi}?interviewId=${interviewData?.interviewId}`;

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setPreviewConfig(result.data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.status === 401) {
          notification.error({
            message: "Unauthorized",
            description: "Token expired! Please login again.",
            placement: "topRight",
            duration: 0,
          });
        }
        console.log(err);
      });
  };

  useEffect(() => {
    if (interviewData) {
      getConfig();
    }
  }, [interviewData]);

  return (
    <>
      {loading && <Loader />}
      {aiTwoWayFlag ? (
        <TwoWayInterview
          socket={socket}
          deepgramStatus={deepgramStatus}
          setDeepgramStatus={setDeepgramStatus}
          interviewData={interviewData}
          ip={ip}
          conversationHistory={conversationHistory}
          previewConfig={previewConfig}
          currentVideoStream={currentVideoStream}
          currentAudioStream={currentAudioStream}
          screenShareStream={screenShareStream}
        />
      ) : (
        <div className="min-h-screen pb-2 py-2 pt-0 flex flex-col justify-between items-center">
          <PreviewNav config={previewConfig} />
          <PreviewScreen
            socket={socket}
            ip={ip}
            setDeepgramStatus={setDeepgramStatus}
            setLoading={setLoading}
            interviewData={interviewData}
            setConversationHistory={setConversationHistory}
            previewConfig={previewConfig}
            setAiTwoWayFlag={setAiTwoWayFlag}
            currentVideoStream={currentVideoStream}
            setCurrentVideoStream={setCurrentVideoStream}
            screenShareStream={screenShareStream}
            setScreenShareStream={setScreenShareStream}
            currentAudioStream={currentAudioStream}
            setCurrentAudioStream={setCurrentAudioStream}
          />
          <PreviewFooter />
        </div>
      )}
    </>
  );
}

export default AiInterviewPreview;
